import React from 'react';
import { EndChatContainer } from './RcsChat.styles';

const RcsEndChat = () => {
  return <EndChatContainer></EndChatContainer>;
};

export default RcsEndChat;
